import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { ChartComponent } from '../chart/chart.component';

import { ReportBuilderComponent } from './report-builder.component';

const routes: Routes = [
  {
    path: '',
    component: ReportBuilderComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DragDropModule,
    ChartComponent,
    NgxTippyModule,
    RouterModule.forChild(routes),
  ],
  declarations: [ReportBuilderComponent],
  exports: [ReportBuilderComponent],
})
export class ReportBuilderModule {}
